// 二级品牌馆配置 登场了
export default {
  'deng.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001676621262',
      storeName: '登场国',
      microHost: 'deng-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001676621262',
      storeName: '登场国',
      microHost: 'deng-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001676621262',
      storeName: '登场国',
      microHost: 'deng-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001676621262',
      storeName: '登场国',
      microHost: 'deng-brand.ubanquan.cn'
    }
  }
};